import React, { PropsWithChildren } from 'react';

import useStyles from './styles';

interface Props {
    picture?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    description?: React.ReactNode;
    additional?: React.ReactNode;
    actions?: React.ReactNode;
    align?: 'left' | 'center' | 'right';
    className?: string;
}

const ContentCard: React.FC<PropsWithChildren<Props>> = ({
    picture,
    title,
    subtitle,
    description,
    additional,
    actions,
    align = 'left',
    children,
    className
}) => {
    const { cx, classes } = useStyles({ align });
    return (
        <section className={cx(classes.root, className)}>
            {picture ? <span className={classes.picture}>{picture}</span> : null}
            {title ? <h2 className={classes.title}>{title}</h2> : null}
            {subtitle ? <div className={classes.subtitle}>{subtitle}</div> : null}
            {description ? <div className={classes.description}>{description}</div> : null}
            {additional ? <span className={classes.additional}>{additional}</span> : null}
            {children}
            {actions ? <div className={classes.actions}>{actions}</div> : null}
        </section>
    );
};

export default ContentCard;
